<div
	class="content-container"
	[appHasSystemCapability]
	[hasOne]="hasOne"
	[has]="has"
	[hasAll]="hasAll"
	unauthorizedAction="show"
>
	<div class="content-container-header">
		<h3 i18n="@@notAuthorizedNoticeComponent-notAuthorizedHeader"><b>Not Authorized</b></h3>
		<p i18n="Not authorized to use this page|@@notAuthorizedNoticeComponent-notAuthorizedMessage">
			You are not authorized to use this page
		</p>
	</div>
</div>
